// extracted by mini-css-extract-plugin
module.exports = {"hidden":"v4Notice_hidden__mTn8R","textEmphasis":"v4Notice_textEmphasis__GosPY","noticeText":"v4Notice_noticeText__6Ouc1"};